import React, {Component} from 'react';
import {observer} from 'mobx-react';
import pdfjs from 'pdfjs-dist/webpack';
import styles from './styles.css';


@observer
export default class Page extends Component {

  constructor() {
    super();
  }

  componentDidMount() {
    const page = this.props.page;
    if (page) {
      console.log(page.getViewport);
      const scale = 150 / page.getViewport(1).height;
      const viewport = page.getViewport(scale);

      // Prepare canvas using PDF page dimensions
      const canvas = this.canvas;
      const context = canvas.getContext('2d');
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      // Render PDF page into canvas context
      page.render({canvasContext: context, viewport: viewport})
    }
  }

  render() {
    return (
      <canvas
        className={styles.page}
        ref={(canvas) => {this.canvas = canvas}}
      >

      </canvas>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Imposer/Page.js